import React, { useState, useEffect } from 'react';
import { SmallClipControls } from '../SmallClipControls/SmallClipControls';
import { IoChevronDownOutline, IoChevronUpOutline } from "react-icons/io5";
import { FormatDate } from '../../helpers/FormatDate';
import { getScreenshotSignedUrl, getClipListens } from '../../services/HalogenService';
import { useNavigate } from 'react-router-dom';
import './MedFedClip.css';

export const MedFedClip = ({ clip, color = '#F2EFF4' }) => {
    const navigate = useNavigate();
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [numListens, setNumListens] = useState(clip.numListens ? clip.numListens : 0);
    const [screenshotUrl, setScreenshotUrl] = useState(clip.imageURL);
    const [isImgLoading, setIsImgLoading] = useState(true);

    const handleNavigate = () => {
        navigate(`/focus/${clip.id}`);
    };

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (!clip.imageURL) {
            getScreenshotSignedUrl(clip.id, 'small')
                .then(url => {
                    setScreenshotUrl(url.signedUrl)
                    setIsImgLoading(true);
                })
                .catch(err => console.error(err));
        }
        if (clip.numListens === undefined) {
            getClipListens(clip.id)
                .then(listens => setNumListens(listens.listens))
                .catch(err => console.error(err));
        }
    }, [clip.id, clip.imageURL, clip.numListens]);

    return (
        <div onClick={handleNavigate} className="medFedClip expanded">
            {isImgLoading && <div className="imagePlaceholder"></div>}
            <div className="medFedImageContainer">
                {screenshotUrl && <img src={screenshotUrl} className={`medFedClipVisualContentImg ${isImgLoading ? 'hidden' : ''}`} onLoad={() => setIsImgLoading(false)} alt="Visual Content" />}
            </div>
            <div className="contentContainer" >
                <div className="textContainer" >
                    <h3 className="medFedClickableTitle" onClick={handleNavigate}>{clip.title}</h3>
                    <p className="medFedDateListens">
                        {FormatDate(clip.created_at)} | {numListens} listens
                    </p>
                    <p className="medFedClipDescription">{clip.description}</p>
                </div>
                <div className="controlsContainer">
                    <SmallClipControls clip={clip} color={'#F2EFF4'} />
                </div>
            </div>
        </div>
    );
};
